import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'preview-error',
  templateUrl: './preview-error.component.html',
  styleUrls: ['./preview-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewErrorComponent {
  @Input() text = 'the preview';
  @Output() again = new EventEmitter();

  tryAgain() {
    this.again.emit();
  }
}
